import { DocumentType } from "constants/TemplateEditor";

export enum TemplateStatus {
  ALL = "all",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum TemplateViewType {
  GRID = "GRID",
  LIST = "LIST",
}

export enum ItemType {
  TEMPLATE = "Template",
  TEXT = "Text",
}

export enum TemplateActions {
  COPY = "COPY",
  DOWNLOAD = "DOWNLOAD",
  CREATE_NEW = "NEW_TEMPLATE",
  EDIT = "NAVIGATE",
  ADD_TO_MAESSAGE_TEMPLATES = "ADD_TO_MAESSAGE_TEMPLATES",
  ACTIVATE_OR_DEACTIVATE = "ACTIVATE_OR_DEACTIVATE",
}

export enum URLParams {
  GROUP_ID = "groupId",
  CATEGORY_ID = "categoryId",
  SEARCH_TEXT = "searchText",
  ACTIVITY_NO = "activityNo",
  DOCUMENT_TYPE = "documentType",
  TEMPLATE_STATUS = "templateStatus",
  DRAWER_TYPE = "drawerType",
  FILTERED = "filtered",
  TEMPLATE_ID = "id",
}

export const INITIAL_FORM_VALUES = {
  categoryId: 0,
  searchText: "",
  activityNo: 0,
  status: TemplateStatus.ALL,
  documentType: DocumentType.ALL,
  offset: 0,
  limit: 1000,
};

export const INITIAL_TEMPLATE_RULES_DATA = {
  id: "",
  templateId: 0,
  templateName: "",
  group: "",
  ruleExpressions: [],
};

export const INITIAL_DRAWER_INFO = {
  title: "",
  visibility: false,
  type: "",
};

export type DrawerInfo = {
  title: string;
  visibility: boolean;
  type: string;
};

export enum DrawerType {
  GLOBAL_RULES = "globalRules",
  SETTINGS = "settings",
}
export const CATEGORY_GROUP = {
  case: "Case",
  subCase: "SubCase",
};

export const ITEM_OPTIONS = [
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.TEMPLATE",
    value: "Template",
  },
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.TEXT",
    value: "Text",
  },
];

export const TEXT_DISPLAY_CATEGORY = "Dashboard Message";

export enum MoreActionType {
  VIEW_DETAILS = "ViewDetails",
  EDIT_DISPLAY_NAME = "EditDisplayName",
}

export const ADAPTER_TYPE_OPTION = [
  {
    label: "SP",
    value: "SP",
  },
  {
    label: "API",
    value: "Api",
  },
];

export enum SortingOrder {
  ASC = "ascending",
  DESC = "descending",
}

export enum SortingOptions {
  LAST_UPDATED_DATE = "lastUpdatedDate",
  CREATED_DATE = "createdDate",
  TEMPLATE_NAME = "templateName",
}

export const SORTING_OPTIONS = [
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.LAST_MODIFIED_DATE",
    value: SortingOptions.LAST_UPDATED_DATE,
  },
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CREATED_DATE",
    value: SortingOptions.CREATED_DATE,
  },
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.TEMPLATE_NAME",
    value: SortingOptions.TEMPLATE_NAME,
  },
];

export const SORTING_ORDER = [
  {
    label: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CLICK_HERE_TO_MAKE_ASCENDING",
    value: SortingOrder.ASC,
  },
  {
    label:
      "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CLICK_HERE_TO_MAKE_DESCENDING",
    value: SortingOrder.DESC,
  },
];

export enum TemplateGroups {
  CASE = "Case",
  SUBCASE = "SubCase",
  DEBTOR = "Debtor",
  CREDITOR = "Creditor",
}

export enum TemplateCategory {
  EHF = "EHF"
}